import { FC, ReactElement } from 'react';
import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
interface CardHeaderProps extends BoxProps {
  text?: string;
  actionComponent?: ReactElement;
}
const CardHeader: FC<CardHeaderProps> = ({
  text,
  actionComponent,
  ...props
}) => {
  return <Flex justifyContent="space-between" alignItems="center" {...props} data-sentry-element="Flex" data-sentry-component="CardHeader" data-sentry-source-file="CbCard.tsx">
      <Text fontSize={{
      base: 'md',
      md: '2xl'
    }} color="text.primaryDark" fontWeight="bold" fontFamily="codenext" data-sentry-element="Text" data-sentry-source-file="CbCard.tsx">
        {text}
      </Text>
      {actionComponent}
    </Flex>;
};
export interface CbCardProps extends BoxProps {
  title?: string;
  headerAction?: ReactElement;
  isMobile?: boolean;
}
export const CbCard: FC<CbCardProps> = ({
  headerAction,
  title,
  children,
  isMobile,
  ...props
}) => {
  return <>
      {!isMobile && <CardHeader text={title} actionComponent={headerAction} marginBottom={4} />}
      <Box borderRadius={24} backgroundColor="white" boxShadow="standardCard" minHeight={40} {...props} data-sentry-element="Box" data-sentry-source-file="CbCard.tsx">
        {isMobile && <CardHeader text={title} actionComponent={headerAction} marginBottom={6} />}
        {children}
      </Box>
    </>;
};